// extracted by mini-css-extract-plugin
export var button = "_ff-4";
export var hasDarkBackground = "_ff-7";
export var hasLightBackground = "_ff-6";
export var iconWrapper = "_ff-0";
export var large = "_ff-2";
export var medium = "_ff-1";
export var small = "_ff-5";
export var xsmall = "_ff-3";